import { NAME } from './constants';
import { State } from '../../common/types/types';

export const getLoginResultCode = (state: State): number | null =>
  state[NAME].loginResultCode;
export const isLoginRunning = (state: State): boolean =>
  state[NAME].loginRunning;
